import React from 'react';
import {
  FDBodyText, FDBox, FDImage, FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const ItemInfoCard = ({
  mediaSrc,
  title,
  description,
}) => {
  return (
    <FDPaper color={'info'} appearance={'flat'} padding={2} width={'100%'}>
      <FDBox paddingX={2}>
        <FDStack direction={'column'} spacing={2} alignItems={'center'}>
          {mediaSrc && <FDImage src={mediaSrc} alt={title} rounded={false} />}
          <FDTitleText value={title} align={'center'} />
          <FDBodyText value={description} align={'center'} />
        </FDStack>
      </FDBox>
    </FDPaper>
  );
};

ItemInfoCard.defaultProps = {
  mediaSrc: undefined,
};

ItemInfoCard.propTypes = {
  mediaSrc: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export { ItemInfoCard };
